function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 138.399,
    height: 37.695,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2031.47 553.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 1015.73,
    y1: 803.04,
    x2: 1015.73,
    y2: 64.04
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 1009.83,
    y1: -66.32,
    x2: 1022.88,
    y2: 619.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#f6b55c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#e2884c"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2031.47 185.71v181.88c0 102.17-95.34 185.71-211.7 185.71H227.33C102.41 553.3 0 467.83 0 363.3V177.16c0-33.85 11.48-65.56 31.53-92.55C51.57 57.4 134.92 36.49 172.58 42.29c20.03 3 28.58 26.1 24.67 17.33-2.45-5.79-3.63-27.69 1.74-35.53C213.1 3.49 266.22.01 276.96.01l1558.08 2.63c129.45 20.28 196.43 80.91 196.43 183.08z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.29 161.99V320.6c0 8.22-.67 16.44-2.28 24.48-3.19 17.38-9.78 33.81-19.33 48.75-7.05 11.59-15.71 22.22-25.72 31.76-19.11 18.49-43.24 33.25-70.31 42.97-24.35 8.97-51.22 14.02-79.43 14.02H281.68c-19.8 0-39.15-2.24-57.36-6.16-53.49-11.96-98.78-39.99-126.08-77.17-6.59-8.97-12.06-18.49-16.61-28.38-7.5-16.82-11.62-35.12-11.62-54V154.52c0-4.11.24-8.22.68-12.32.47-5.99 1.61-11.98 3.2-17.74 4.55-18.34 13.43-35.32 25.48-50.65 18.67-23.72 54.86-35.49 89.91-30.45 18.66 2.62 38.47 4.68 55.3 7.11 10.24 1.49 19.35-6.36 15.71-14.02-2.26-5.04-2.5-13.84-2.05-21.66.45-8.23 8.64-14.76 18.66-14.76h1487.32c44.82 0 86.47 12.52 119.7 33.62 15.02 9.35 28.23 20.36 39.13 32.88 13.89 15.5 24.59 33.25 30.97 52.13a132.21 132.21 0 0 1 7.28 43.33z",
    style: {
      fill: "url(#b)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestAnswer);
export default __webpack_public_path__ + "static/media/quest_answer.7a3021b6e06864af241a4ecce6b51e18.svg";
export { ForwardRef as ReactComponent };